import { dateUtils } from '../../../../lib/date-utils';
import I18n from '../../../../lib/i18n';
import { getRenewalDate } from '../../../../lib/date-utils';

export const getFutureStatusDate = date => {
  const daysLeft = dateUtils.getDaysLeftBeforeDate(date);
  return daysLeft > 1 ? `${I18n.t('on')} ${getRenewalDate(date)}` : `${I18n.t('at')} ${dateUtils.format(date, 'p')}`;
};

export const getFutureStatusText = (daysLeft, hasNextPlan, isLineOFF, isModeOn) => {
  if (isLineOFF) {
    return I18n.t(daysLeft > 1 ? 'Dashboard.PlanRenewal.lineTerminationIn' : 'Dashboard.PlanRenewal.lineTermination');
  }
  if (isModeOn) {
    return hasNextPlan ? I18n.t(daysLeft > 1 ? 'changesIn' : 'changes') : I18n.t(daysLeft > 1 ? 'renewsIn' : 'renews');
  }
  return I18n.t(daysLeft > 1 ? 'stopsIn' : 'stops');
};
